import React from "react";
import { useIntl } from "react-intl";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText
} from "@material-ui/core";

interface IProps {
  open: boolean;
}

function FormSubmittedDialog(props: IProps) {
  const intl = useIntl();

  const handleClose = () => {
    window.location.reload();
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      disableAutoFocus={true}
      disableBackdropClick={true}
    >
      <DialogTitle>{intl.formatMessage({ id: "REQUEST_SUBMITTED_SUCCESSFULLY" })}</DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText>{intl.formatMessage({ id: "FORM_SUBMITTED_TEXT" })}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="secondary">
          {intl.formatMessage({ id: "OK" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FormSubmittedDialog;
